var classes = {
  "root": "m_5f93f3bb",
  "input": "m_926b4011",
  "track": "m_9307d992",
  "thumb": "m_93039a1d",
  "trackLabel": "m_8277e082"
};
export { classes as default };